import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL providerS
export const providerList = (params = '') => Http.get(`/marketing-providers${serialize(params)}`)
export const providerCreate = (params = '') => Http.post('/marketing-providers', params)
export const providerByID = (params = '') => Http.get(`/marketing-providers/${params}`)
export const providerUpdate = (params = '') => Http.put(`/marketing-providers/${params.id}`, params)
export const providerDestroy = (params = '') => Http.delete(`/marketing-providers/${params.id}`)
